import { appPath, workAreaRoutePath } from '@featit/shared/addressing/paths';

export function projectDocumentsPath(projectSlug?: string | null): string {
  return projectSlug ? workAreaRoutePath(projectSlug, '/documents') : appPath('/documents');
}

export function projectDocumentPath(
  projectSlug: string | null | undefined,
  documentId: string | null | undefined,
): string {
  const basePath = projectDocumentsPath(projectSlug);
  return documentId ? `${basePath}/${encodeURIComponent(documentId)}` : basePath;
}
